import { alpha, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { Bell } from "lucide-react";
import { ReminderBadge } from "web_myplann/Reminders/Components/ReminderBadge";
import { ReminderRemoveButton } from "web_myplann/Reminders/Components/ReminderRemoveButton";
import { ReminderRowMeta } from "web_myplann/Reminders/Components/ReminderRowMeta";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const ICON_BOX_SIZE = 32;
const ICON_GLYPH_SIZE = 16;

type Props = {
	reminder: Reminder;
	highlighted?: boolean;
	onTap: () => void;
	onRemove: () => void;
	id?: string;
};

export const ReminderFlatRow = ({
	reminder,
	highlighted = false,
	onTap,
	onRemove,
	id,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack
			id={id}
			component={ButtonBase}
			direction="row"
			alignItems="center"
			onClick={onTap}
			width="100%"
			textAlign="left"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			gap={theme.spacingTokens.md}
			bgcolor={highlighted ? alpha(theme.palette.blue[50], 0.7) : "transparent"}
			sx={{
				transition: "background-color 300ms",
				"& + &": {
					borderTop: theme.colors.border.solid(theme.palette.divider),
				},
				"&:active": { bgcolor: theme.palette.grey[50] },
			}}
		>
			<IconBox bg={theme.palette.blue[50]} size={ICON_BOX_SIZE}>
				<Bell size={ICON_GLYPH_SIZE} color={theme.palette.blue[600]} />
			</IconBox>

			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyMedium" noWrap>
					{reminder.name}
				</Typography>
				<ReminderRowMeta reminder={reminder} />
			</Stack>

			<ReminderBadge reminder={reminder} />

			<ReminderRemoveButton appearance="flat" onRemove={onRemove} />
		</Stack>
	);
};
